import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import SearchIcon from "@atlaskit/icon/core/search";
import { token } from "@atlaskit/tokens";

const searchIconStyle = css({
    "marginInlineStart": "8px",
    "background": "transparent",
    "border": 0,
    "cursor": "pointer",
    "padding": 0,
    "color": "#64686f",
    "&:hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        svg: {
            // eslint-disable-next-line local/ensure-wac-token-usage
            backgroundColor: "#dfe1e5"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "svg": {
        // eslint-disable-next-line local/ensure-wac-token-usage
        color: "#101214",
        borderRadius: "50%",
        height: "auto",
        padding: "5px",
        width: "32px",
        minWidth: "32px"
    }
});

export const SearchButton = () => {
    const intl = useIntl();
    const translated = {
        searchLabel: intl.formatMessage({
            id: "CustomerLandingPage.search.label",
            defaultMessage: "Search"
        })
    };

    return (
        <button
            type="submit"
            css={searchIconStyle}
            id="customer-story-search-icon"
            aria-label={translated.searchLabel}
            data-event="clicked"
            data-event-component="button"
            data-event-container="customerStorySearchButton"
            data-product-key="customer"
        >
            <SearchIcon
                label={translated.searchLabel}
                color={token("color.icon")}
            />
        </button>
    );
};
